import axios from "axios";
import Swal from 'sweetalert2';

const modal = Swal.mixin({
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-link',
  },
});

export default {
  install(app) {
    app.config.globalProperties.$nlhpc = {
      isLoggedIn() {
        return !!JSON.parse(localStorage.getItem("user"));
      },

      getUser() {
        if (!this.isLoggedIn()) return false;
        return JSON.parse(localStorage.getItem("user"));
      },

      getBearerToken() {
        return localStorage.getItem("token") || false;
      },

      initRecaptcha(recaptchaSiteKey) {
        if (!document.querySelector("#script-recaptcha")) {
          let script = document.createElement("script");
          script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
          script.id = "script-recaptcha";
          document.body.appendChild(script);
        }
      },

      async animate(element, animation, prefix = "animate__") {
        new Promise((resolve) => {
          const animationName = `${prefix}${animation}`;
          const node = document.querySelector(element);

          if (!node) {
            console.log("element", element);
            console.log("animation", animation);
            console.log("ups!", node);
            return;
          }

          node.classList.add(`${prefix}animated`, animationName);
          function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);
            resolve("Animation ended");
          }

          node.addEventListener("animationend", handleAnimationEnd, {
            once: true,
          });

          console.log("ejecutando animacion", node);
        });
      },

      spinnerLoader(text) {
        return `
          <div class="text-center">
            <div class="spinner-border spinner-border-sm" role="status"></div>
            <br v-if="twoLines" />
            <span v-else>&nbsp;&nbsp; </span>
            <span>${text}</span>
          </div>
        `;
      },

      async validateToken(tokenValidate) {
        try {
          // let tokenValidate = this.$route.params.token;
          if (!!!tokenValidate) return;

          const API_BASE_URL = process.env.VUE_APP_API_URL;
          const options = {
            method: "POST",
            url: `${API_BASE_URL}/login/validate_link`,
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              code: tokenValidate,
            },
          };

          let request = await axios.request(options);
          if (request.status == 200) return true;
          else return false;
        } catch (error) {
          if (process.env.VUE_APP_MODE === "development")
            console.log("Error validateToken : ", error);
          return false;
        }
      },

      async modalUnban(user) {
        let awaitResponse = false;
        let isBanned = !!user.ban_ip;

        if (!isBanned) {
          await modal.fire(`Info`, `Su IP ${user.user_ip} no está bloqueada.`, `info`);
          return true;
        }

        await modal
          .fire({
            title: `IP ${user.user_ip} bloqueada`,
            html:
              "La IP ha sido bloqueada por intentos de conexión SSH al servidor <b>leftraru.nlhpc.cl</b>.<br><br>¿Desea solicitar el desbloqueo?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, desbloquear mi IP",
            cancelButtonText: "No, por ahora",
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
              try {
                await this.unbanIP();
                return true;
              } catch (error) {
                modal.showValidationMessage("Hubo un error al desbloquear la IP.");
                return false;
              }
            }
          }).then(async (result) => {
            if (result.isConfirmed) awaitResponse = true;
          });

        return awaitResponse;
      },

      async unbanIP() {
        try {
          let API_BASE_URL = process.env.VUE_APP_API_URL;
          const options = {
            method: "PUT",
            url: `${API_BASE_URL}/user/ip_bloqueada`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.getBearerToken()}`,
            },
          };

          let response = await axios.request(options);

          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: "IP desbloqueada correctamente.",
            }).then(() => {
              location.href = "/";
            });
          }
        } catch (error) {
          if (process.env.VUE_APP_MODE === "development") {
            console.log("Error en LoginView.vue", error);
            Swal.fire("Error", error.message, "error");
          }
        }
      },

      hasNoticias() {
        return !!parseInt(localStorage.getItem("hasNoticias")) > 0;
      },

      isSmallScreen() {
        let width = Number(window.innerWidth);
        return width < 1200 ? true : false;
      },

      isDarkMode() {
        let theme = localStorage.getItem("_theme");
        console.log("theme", theme);
        return theme === "dark";
      },

      dateFormat(fechaString) {
        if (!fechaString) return '';
        let d = new Date(fechaString);

        let datePart = d.toLocaleDateString('es-CL', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).replace(/\//g, '-');

        let timePart = d.toLocaleTimeString('es-CL', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        return `${timePart} ${datePart}`;
      }
    };
  },
};
